import Icon from "assets/icons";
import { useCopies } from "shared/hooks/useCopies";

export default function NoTicketsAvailable() {
  const copies = useCopies();
  return (
    <section className="noTicketSection">
      <div className="noTicketsAvailable">
        <div className="noTicketsAvailable_content">
          <Icon.Block />
          <p>{copies.get("no.tickets.available")}</p>
        </div>
      </div>
    </section>
  );
}
